import React from 'react';

const Page404 = () => <div>Page 404</div>;

export default Page404;
